import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-529babb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"5px","font-size":"18px","background-color":"transparent","line-height":"20px","color":"#fff"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"500"} }, "Food"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "Futures")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","bottom":"5px","left":"18px","color":"rgba(255, 255, 255, 0.3)"} }, "v1.1", -1))

import {
  IonApp,
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
  IonImg
} from "@ionic/vue";
import { ref } from "vue";
import {
  pieChart,
  statsChart,
  document,
  analytics,
  create,
  logOut,
  personOutline
} from "ionicons/icons";


export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarLayout',
  setup(__props) {

const selectedIndex = ref(0);
const appPagesTop = [
  {
    title: "Dashboard",
    url: "/",
    iosIcon: pieChart,
    mdIcon: pieChart,
  },
  {
    title: "Performance",
    url: "/performance",
    iosIcon: analytics,
    mdIcon: analytics,
  },
  {
    title: "Priorities",
    url: "/priorities",
    iosIcon: statsChart,
    mdIcon: statsChart,
  }, 
  {
    title: "Scenarios",
    url: "/scenarios",
    iosIcon: document,
    mdIcon: document,
  },
  // {
  //   title: "Glossary",
  //   url: "/glossary",
  //   iosIcon: create,
  //   mdIcon: create,
  // },
];
const appPagesBottom = [
  {
    title: "Admin Farms",
    url: "/admin/farms",
    iosIcon: analytics,
    mdIcon: analytics,
  },
  {
    title: "Admin Global Stats",
    url: "/admin/globalstats",
    iosIcon: analytics,
    mdIcon: analytics,
  },
  {
    title: "Profile",
    url: "/profile",
    iosIcon: personOutline,
    mdIcon: personOutline,
  },
  {
    title: "Logout",
    url: "/login",
    iosIcon: logOut,
    mdIcon: logOut,
  },
];

const isAdmin = window.localStorage.getItem("isAdmin") === "true";
const path = window.location.pathname;
if (path !== undefined) {
  selectedIndex.value = appPagesTop.findIndex(
    (page) => page.url === path.toLowerCase()
  );
}

function handleBottomMenuItemClick(i: number) {
  selectedIndex.value = (i + appPagesTop.length)
  if (appPagesBottom[i].url === "/login") {
    logout();
  }
}

function logout() {
  window.localStorage.clear();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonMenu), {
            "content-id": "main-content",
            type: "overlay",
            style: {"margin":"5px","border-radius":"16px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonList), {
                    class: "h-100 d-flex flex-column",
                    id: "inbox-list"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonListHeader), null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonImg), {
                            style: {"height":"36px","width":"36px"},
                            src: require('@/assets/images/logo.png'),
                            alt: "Logo"
                          }, null, 8, ["src"]),
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appPagesTop, (p, i) => {
                        return _createVNode(_unref(IonMenuToggle), {
                          "auto-hide": false,
                          key: i
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(IonItem), {
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (selectedIndex.value = i),
                              "router-direction": "root",
                              "router-link": p.url,
                              lines: "none",
                              detail: false,
                              class: _normalizeClass(["hydrated", { selected: selectedIndex.value === i }])
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(IonIcon), {
                                  slot: "start",
                                  ios: p.iosIcon,
                                  md: p.mdIcon
                                }, null, 8, ["ios", "md"]),
                                _createVNode(_unref(IonLabel), null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(p.title), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick", "router-link", "class"])
                          ]),
                          _: 2
                        }, 1024)
                      }), 64)),
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(appPagesBottom, (p, i) => {
                        return _createVNode(_unref(IonMenuToggle), {
                          "auto-hide": false,
                          key: i,
                          class: _normalizeClass(i === 0 ? 'mt-auto' : '')
                        }, {
                          default: _withCtx(() => [
                            ((p.url.includes('admin') && isAdmin) || !p.url.includes('admin'))
                              ? (_openBlock(), _createBlock(_unref(IonItem), {
                                  key: 0,
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (handleBottomMenuItemClick(i)),
                                  "router-direction": "root",
                                  "router-link": p.url,
                                  lines: "none",
                                  detail: false,
                                  class: _normalizeClass(["hydrated", { selected: selectedIndex.value === (i + appPagesTop.length) }])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      slot: "start",
                                      ios: p.iosIcon,
                                      md: p.mdIcon
                                    }, null, 8, ["ios", "md"]),
                                    _createVNode(_unref(IonLabel), null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(p.title), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "router-link", "class"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      }), 64))
                    ]),
                    _: 1
                  }),
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})